export const who = ()=> {
    let whoLineTriggers = [];
    let whoItemTitleTriggers = [];
    let whoItemImageTriggers = [];

    const whoSection = document.querySelectorAll('.who')

    whoSection?.forEach(section=> {
        const whoLine = section?.querySelector('.who__line')
        const whoItems = section?.querySelectorAll('.who__item')
        const whoLineItems = section?.querySelectorAll('.who__line-item')
        const whoItemImages = section?.querySelectorAll('.who__item-image')

        const whoLineAnimation = ()=> {

            if (whoItems.length > 0) {
                whoLineTriggers.forEach(trigger => trigger.kill());
                whoItemTitleTriggers.forEach(trigger => trigger.kill());
                whoItemImageTriggers.forEach(trigger => trigger.kill());

                whoLineTriggers = [];
                whoItemTitleTriggers = [];
                whoItemImageTriggers = [];

                const trigger1 = ScrollTrigger.create({
                    trigger: whoItems[0]?.querySelector('.who__item-title'),
                    start: 'top 85%',
                    end: `${whoLine.scrollHeight}px 10%`,
                    onUpdate: self => {
                        if (window.scrollY > ((whoLine.getBoundingClientRect().top + window.scrollY) - (window.innerHeight / 2))) {
                            const scrollOffsetTop = window.scrollY - ((whoLine.getBoundingClientRect().top + window.scrollY) - (window.innerHeight / 2))
                            whoLineItems?.forEach((item,index)=> {
                                const offsetTopBlockItem = window.matchMedia("(min-width:1024px)").matches ? (whoItems[index].offsetTop + (whoItems[index].clientHeight / 2)) : whoItems[index].offsetTop
                                if (scrollOffsetTop > offsetTopBlockItem) {
                                    item.classList.add('fixed')
                                    item.style = `top:${offsetTopBlockItem}px;transition: top ${0}s, opacity 1s,transform 1s;`
                                } else {
                                    item.classList.remove('fixed')
                                    // item.style = `top:${scrollOffsetTop}px;transition: top ${0}s, opacity 1s,transform 1s;`
                                    item.style = `top:${50}dvh;transition: top ${0}s, opacity 1s,transform 1s;`
                                }
                            })
                        } else {
                            whoLineItems?.forEach((item)=> {
                                item.classList.remove('fixed')
                                // item.style = `top:${whoItems[0].offsetTop}px;transition: top ${1}s, opacity 1s,transform 1s;`
                            })
                        }
                    },
                    onEnter: () => {
                        whoLine.classList.add('play');
                        // whoLineItems?.forEach((item)=> {
                        //     item.style = `top:${whoItems[0].offsetTop}px;transition: top ${1}s, opacity 1s;`
                        // })
                    },
                    onLeaveBack: () => {
                        whoLine.classList.remove('play');
                        // whoLineItems?.forEach((item)=> {
                        //     item.style = `top:0px;transition: top ${1}s, opacity 1s;`
                        // })
                    },
                });

                whoLineTriggers.push(trigger1);

                if (window.matchMedia("(min-width:1024px)").matches) {
                    gsap.utils.toArray('.who__item-title').forEach((item,index) => {
                        const trigger2 = ScrollTrigger.create({
                            trigger: item,
                            start: 'top 85%',
                            end: 'bottom 10%',
                            onEnter: () => {
                                whoItemImages[index]?.classList.add('play')
                            },
                            onLeaveBack: () => {
                                whoItemImages[index]?.classList.remove('play')
                            },
                        });
                        whoItemTitleTriggers.push(trigger2);
                    })
                } else {
                    gsap.utils.toArray(whoItemImages).forEach((item) => {
                        const trigger3 = ScrollTrigger.create({
                            trigger: item,
                            start: 'top 85%',
                            end: 'bottom 10%',
                            onEnter: () => {
                                item.classList.add('play')
                            },
                            onLeaveBack: () => {
                                item.classList.remove('play')
                            },
                        });
                        whoItemImageTriggers.push(trigger3);
                    })
                }
            }
        }

        whoLineAnimation()

    })

}